import Contact from '../model/Contact/contact';
import { CollectionHelper } from './collection-helper';
import { FormatPhoneNumber } from '../modules/app-pipes/format-phonenumber';
import { User } from '../model/user';
import { StringHelper } from './string-helper';

export class ContactHelper {
  private constructor() {}

  public static setFormDisplays(
    contact: Contact,
    formatPhoneNumber: FormatPhoneNumber
  ) {
    this.setPhoneNumberDisplays(contact, formatPhoneNumber);
    this.setEmailDisplay(contact);
  }

  public static setPhoneNumberDisplays(
    contact: Contact,
    formatPhoneNumber: FormatPhoneNumber
  ): void {
    if (contact == null || !CollectionHelper.isPopulated(contact.telephones)) {
      return;
    }
    let phoneNumberSet = false;
    let mobileNumberSet = false;
    for (const number of contact.telephones) {
      if (number.type === 'phone') {
        contact.phoneNumberDisplay = formatPhoneNumber.transformTelephone(
          number
        );
        phoneNumberSet = true;
      }
      if (number.type === 'mobile') {
        contact.mobileNumberDisplay = formatPhoneNumber.transformTelephone(
          number
        );
        mobileNumberSet = true;
      }
      if (phoneNumberSet && mobileNumberSet) {
        break;
      }
    }
  }

  public static setEmailDisplay(contact: Contact) {
    if (contact == null || !CollectionHelper.isPopulated(contact.emails)) {
      return;
    }
    const email = contact.emails.find(e => e.email != null);
    contact.emailDisplay = email.email;
  }

  public static getMatchingContact(contacts: Contact[], user: User): Contact {
    if (!CollectionHelper.isPopulated(contacts) || user == null) {
      return null;
    }

    let matchingEmailContact = null;

    for (const contact of contacts) {
      if (!contact.archived && this.contactMatchesUserMail(contact, user)) {
        if (this.contactMatchesUserName(contact, user)) {
          return contact;
        }
        matchingEmailContact =
          matchingEmailContact == null ? contact : matchingEmailContact;
      }
    }

    return matchingEmailContact;
  }

  private static contactMatchesUserMail(contact: Contact, user: User): boolean {
    return (
      CollectionHelper.isPopulated(contact.emails) &&
      contact.emails.some(e => e.email === user.email)
    );
  }

  private static contactMatchesUserName(contact: Contact, user: User): boolean {
    return (
      StringHelper.equalUnderTransforms(
        contact.firstName,
        user.firstName == null ? null : user.firstName.toString(),
        String.prototype.trim,
        String.prototype.toLowerCase
      ) &&
      StringHelper.equalUnderTransforms(
        contact.lastName,
        user.lastName == null ? null : user.lastName.toString(),
        String.prototype.trim,
        String.prototype.toLowerCase
      )
    );
  }

  public static getContactDisplay(
    contact: Contact,
    formatPhoneNumber: FormatPhoneNumber
  ): string {
    this.setPhoneNumberDisplays(contact, formatPhoneNumber);
    this.setEmailDisplay(contact);
    return (
      StringHelper.join([contact.firstName, contact.lastName], ' ') +
      ' - ' +
      ContactHelper.displayIfNotEmpty(contact.phoneNumberDisplay) +
      ContactHelper.displayIfNotEmpty(contact.mobileNumberDisplay) +
      ContactHelper.displayIfNotEmpty(contact.emailDisplay, true)
    );
  }

  public static displayIfNotEmpty(value: string, lastValue = false): string {
    return value != null && value.trim() != ''
      ? value + `${lastValue ? '' : ' - '}`
      : '';
  }
}
